import {
  ID_COLLECT_VOYAGE,
  ID_DELIVERY_VOYAGE,
  ID_FINAL_DESTINATION_VOYAGE,
  ID_RECEIVING_LOCATION,
} from "views/ProcessDetails/utils/constants";

export const getLocationType = (
  isAiProcess: boolean,
  typeVoyage?: number | null,
) => {
  if (!isAiProcess) {
    return "PORTO,OUTROS";
  }
  if (
    typeVoyage &&
    [
      ID_FINAL_DESTINATION_VOYAGE,
      ID_COLLECT_VOYAGE,
      ID_DELIVERY_VOYAGE,
      ID_RECEIVING_LOCATION,
    ].includes(typeVoyage)
  ) {
    return "AEROPORTO,OUTROS";
  }
  return "AEROPORTO";
};
